export enum TipoRepresentacao {
  CIDADAO = 'Cidadão',
  SCO = 'SCO - Sociedade Civil Organizada',
  AGENTE_PUBLICO_EXECUTIVO = 'Agente Público - Poder Executivo',
  AGENTE_PUBLICO_LEGISLATIVO = 'Agente Público - Poder Legislativo'
}

export const TIPO_REPRESENTACAO_OPTIONS = [
  {label: 'Cidadão', value: TipoRepresentacao.CIDADAO},
  {label: 'SCO - Sociedade Civil Organizada', value: TipoRepresentacao.SCO},
  {label: 'Agente Público - Poder Executivo', value: TipoRepresentacao.AGENTE_PUBLICO_EXECUTIVO},
  {label: 'Agente Público - Poder Legislativo', value: TipoRepresentacao.AGENTE_PUBLICO_LEGISLATIVO}
];


/**
 * Retorna o label correspondente ao value do enum TipoRepresentacao.
 * @param value Valor do enum TipoRepresentacao
 * @returns Label correspondente ou undefined
 */
export function getTipoRepresentacaoLabel(value: string | TipoRepresentacao): string {
  return (
    TIPO_REPRESENTACAO_OPTIONS.find(opt => opt.value === value)?.label ?? value
  );
}
